export default __webpack_public_path__ + "static/IBM-Plex-Mono-700-af540dcfdbb0cb8d810eaab049dffdeb.woff";